<div class="time-picker" [class.disabled]="isDisabled">
  <div class="inputs-container">
    <div class="hours-wrapper">
      <input
        #hoursInput
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        [value]="hours"
        (focus)="onHoursFocus()"
        (input)="onHoursInput($event)"
        (blur)="onHoursBlur()"
        [disabled]="isDisabled"
        class="time hours-input"
        maxlength="2"
      />

      <div class="dropdown-list" *ngIf="isDropdownOpen">
        <div
          *ngFor="let hour of hoursList"
          class="dropdown-item"
          [class.selected]="hour === hours"
          (click)="selectHour(hour)"
        >
          {{ hour }}
        </div>
      </div>
    </div>

    <span class="delimiter">:</span>

    <input
      type="text"
      [value]="minutes"
      disabled
      class="time minutes-input"
      tabindex="-1"
    />
  </div>

  <button
    type="button"
    class="clock-button"
    (click)="toggleDropdown($event)"
    [disabled]="isDisabled"
    tabindex="-1"
  >
    <img src="assets/svg-icons/time.svg" alt="time">
  </button>
</div>
